import { RowExportTypePdf } from "types";
import { PdfTemplate } from "components";
import { DataList } from "../types";

export function PdfRoleManagement(props: { dataList: DataList[] }) {
  const columns = [
    { header: "NO", key: "no", width: 5 },
    { header: "GROUP POSITION", key: "group_position", width: 10 },
    { header: "DESCRIPTION", key: "description", width: 15 },
  ];

  const dataMap: RowExportTypePdf[] = props.dataList.map((item, index) => ({
    no: index + 1,
    group_position: item.group_position_name ?? "-",
    description: item.description ?? "-",
  }));

  return <PdfTemplate data={dataMap} column={columns} title="Group Position" />;
}
